module.exports = __webpack_public_path__ + "fonts/HYK2GJM.3c590e54.TTF";